var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt-4" },
    [
      _c("h5", [_vm._v("Configuración de estampa")]),
      _c("p", { staticStyle: { color: "#4e4e4e", "font-size": "0.9rem" } }, [
        _vm._v(
          " Configure cómo se verá su firma electrónica al estamparse en los documentos. "
        )
      ]),
      _c("div", { staticClass: "divider mb-3" }),
      _c("div", { staticClass: "mb-3" }, [
        _c("label", { staticClass: "font-weight-bold" }, [
          _vm._v("Tipo de estampa")
        ]),
        _c(
          "div",
          { staticClass: "d-flex mt-2" },
          _vm._l(_vm.typeOptions, function(option) {
            return _c(
              "div",
              { key: option.value, staticClass: "form-check mr-4" },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.config.tipo,
                      expression: "config.tipo"
                    }
                  ],
                  staticClass: "form-check-input",
                  attrs: { type: "radio", id: "stamp-type-" + option.value },
                  domProps: {
                    value: option.value,
                    checked: _vm._q(_vm.config.tipo, option.value)
                  },
                  on: {
                    change: function($event) {
                      return _vm.$set(_vm.config, "tipo", option.value)
                    }
                  }
                }),
                _c(
                  "label",
                  {
                    staticClass: "form-check-label",
                    attrs: { for: "stamp-type-" + option.value }
                  },
                  [_vm._v(" " + _vm._s(option.label) + " ")]
                )
              ]
            )
          }),
          0
        )
      ]),
      _vm.config.tipo === "2"
        ? _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-md-7" },
              [
                _c("StampTemplateEditor", {
                  attrs: {
                    stampWidth: _vm.effectiveAncho,
                    stampHeight: _vm.effectiveAlto
                  },
                  model: {
                    value: _vm.config.plantilla,
                    callback: function($$v) {
                      _vm.$set(_vm.config, "plantilla", $$v)
                    },
                    expression: "config.plantilla"
                  }
                }),
                _c(
                  "div",
                  { staticClass: "mt-3 mb-3" },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "outline-secondary", size: "sm" },
                        on: {
                          click: function($event) {
                            return _vm.$refs.rubricaModal.show()
                          }
                        }
                      },
                      [
                        _c("feather-icon", {
                          staticClass: "mr-1",
                          attrs: { icon: "EditIcon", size: "14" }
                        }),
                        _vm._v(" Configurar rúbrica (firma manuscrita) ")
                      ],
                      1
                    ),
                    _vm.config.representacion
                      ? _c("span", { staticClass: "ml-2" }, [
                          _c("img", {
                            staticClass: "border rounded",
                            staticStyle: { "max-height": "30px" },
                            attrs: { src: _vm.imageFullUrl, alt: "Rúbrica" }
                          })
                        ])
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            ),
            _c("div", { staticClass: "col-md-5" }, [
              _c(
                "div",
                {
                  staticClass: "sticky-top preview-column",
                  style: _vm.previewColumnStyle
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex align-items-center justify-content-end mb-1"
                    },
                    [
                      _c(
                        "label",
                        { staticClass: "small text-muted mb-0 mr-2" },
                        [_vm._v("Zoom")]
                      ),
                      _c("b-form-select", {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.hover",
                            modifiers: { hover: true }
                          }
                        ],
                        staticStyle: { width: "auto" },
                        attrs: {
                          size: "sm",
                          options: _vm.zoomOptions,
                          title: _vm.zoomTooltip
                        },
                        model: {
                          value: _vm.previewZoom,
                          callback: function($$v) {
                            _vm.previewZoom = _vm._n($$v)
                          },
                          expression: "previewZoom"
                        }
                      }),
                      _c("feather-icon", {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.hover",
                            modifiers: { hover: true }
                          }
                        ],
                        staticClass: "ml-1 text-muted",
                        attrs: {
                          icon: "InfoIcon",
                          size: "14",
                          title: _vm.zoomTooltip
                        }
                      })
                    ],
                    1
                  ),
                  _c("StampPreviewCanvas", {
                    attrs: {
                      template: _vm.config.plantilla,
                      representationUrl: _vm.representationFullUrl,
                      backgroundUrl: _vm.backgroundFullUrl,
                      stampWidth: _vm.effectiveAncho,
                      stampHeight: _vm.effectiveAlto,
                      zoom: _vm.previewZoom,
                      userData: _vm.previewUserData,
                      companyData: _vm.previewCompanyData
                    },
                    on: {
                      "update-position": _vm.onElementPositionUpdate,
                      "update-size": _vm.onElementSizeUpdate
                    }
                  }),
                  _vm.serverPreviewUrl
                    ? _c("div", { staticClass: "mt-3" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-content-between align-items-center"
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "small font-weight-bold text-muted mb-0"
                              },
                              [_vm._v("Resultado final")]
                            ),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "badge badge-light border text-muted ml-2",
                                attrs: {
                                  title: "Ancho x alto que se está usando"
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.effectiveAncho) +
                                    " × " +
                                    _vm._s(_vm.effectiveAlto) +
                                    " "
                                )
                              ]
                            )
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "border rounded p-2 bg-white mt-1 resultado-final-box",
                            style: _vm.resultadoFinalStyle
                          },
                          [
                            _c("img", {
                              staticClass: "resultado-final-img",
                              attrs: {
                                src: _vm.serverPreviewUrl,
                                alt: "Preview final"
                              }
                            })
                          ]
                        )
                      ])
                    : _vm._e(),
                  _c(
                    "b-button",
                    {
                      staticClass: "mt-2",
                      attrs: {
                        variant: "outline-primary",
                        size: "sm",
                        block: "",
                        disabled: _vm.loadingPreview
                      },
                      on: { click: _vm.refreshServerPreview }
                    },
                    [
                      _vm.loadingPreview
                        ? _c("b-spinner", {
                            staticClass: "mr-1",
                            attrs: { small: "" }
                          })
                        : _c("feather-icon", {
                            staticClass: "mr-1",
                            attrs: { icon: "EyeIcon", size: "14" }
                          }),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.loadingPreview
                              ? "Generando..."
                              : "Ver resultado final"
                          ) +
                          " "
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        : _vm._e(),
      _vm.config.tipo === "1" || _vm.config.tipo === "3"
        ? _c("div", { staticClass: "mb-4" }, [
            _c("label", { staticClass: "font-weight-bold" }, [
              _vm._v("Imagen de la estampa")
            ]),
            _c("p", { staticClass: "small text-muted mb-2" }, [
              _vm._v(
                " Suba una imagen PNG o JPG que se usará como estampa de firma. "
              )
            ]),
            _c("input", {
              ref: "imageInput",
              staticClass: "form-control-file",
              attrs: { type: "file", accept: "image/png,image/jpeg" },
              on: { change: _vm.onImageSelected }
            }),
            _vm.config.imagen || _vm.localImagePreview
              ? _c("div", { staticClass: "mt-2" }, [
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v("Imagen actual:")
                  ]),
                  _c("img", {
                    staticClass: "mt-1 border rounded",
                    staticStyle: {
                      "max-width": "300px",
                      "max-height": "100px",
                      display: "block"
                    },
                    attrs: {
                      src: _vm.localImagePreview || _vm.imagenCargadaUrl,
                      alt: "Estampa cargada"
                    }
                  })
                ])
              : _vm._e()
          ])
        : _vm._e(),
      _c("div", { staticClass: "mb-3" }, [
        _c("label", { staticClass: "font-weight-bold" }, [
          _vm._v("Dimensiones de la estampa")
        ]),
        _c("p", { staticClass: "small text-muted mb-2" }, [
          _vm._v(
            " Tamaño con el que se dibujará la estampa en el documento. La vista previa respeta estas proporciones. Por defecto " +
              _vm._s(_vm.defaultAncho) +
              " de ancho por " +
              _vm._s(_vm.defaultAlto) +
              " de alto. "
          )
        ]),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-6 col-md-3" }, [
            _c("label", { staticClass: "small" }, [_vm._v("Ancho")]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: _vm.config.ancho,
                  expression: "config.ancho",
                  modifiers: { number: true }
                }
              ],
              staticClass: "form-control form-control-sm",
              attrs: {
                type: "number",
                min: "1",
                placeholder: String(_vm.defaultAncho)
              },
              domProps: { value: _vm.config.ancho },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.config, "ancho", _vm._n($event.target.value))
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            })
          ]),
          _c("div", { staticClass: "col-6 col-md-3" }, [
            _c("label", { staticClass: "small" }, [_vm._v("Alto")]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: _vm.config.alto,
                  expression: "config.alto",
                  modifiers: { number: true }
                }
              ],
              staticClass: "form-control form-control-sm",
              attrs: {
                type: "number",
                min: "1",
                placeholder: String(_vm.defaultAlto)
              },
              domProps: { value: _vm.config.alto },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.config, "alto", _vm._n($event.target.value))
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            })
          ])
        ])
      ]),
      _c(
        "div",
        { staticClass: "d-flex justify-content-end mt-3" },
        [
          _c(
            "b-button",
            {
              attrs: { variant: "primary", disabled: _vm.saving },
              on: { click: _vm.saveConfiguration }
            },
            [
              _vm.saving
                ? _c("b-spinner", { staticClass: "mr-1", attrs: { small: "" } })
                : _vm._e(),
              _vm._v(" Guardar configuración ")
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "rubricaModal",
          attrs: {
            title: "Configurar rúbrica (firma manuscrita)",
            "hide-footer": "",
            centered: "",
            size: "lg"
          },
          on: { shown: _vm.onRubricaModalShown }
        },
        [
          _c("p", { staticClass: "text-muted small mb-3" }, [
            _vm._v(
              " Esta imagen se superpone a la estampa como representación visual de su firma. "
            )
          ]),
          _c("div", { staticClass: "d-flex mb-3" }, [
            _c("div", { staticClass: "form-check mr-4" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.representationMode,
                    expression: "representationMode"
                  }
                ],
                staticClass: "form-check-input",
                attrs: { type: "radio", id: "rep-draw", value: "draw" },
                domProps: { checked: _vm._q(_vm.representationMode, "draw") },
                on: {
                  change: function($event) {
                    _vm.representationMode = "draw"
                  }
                }
              }),
              _c(
                "label",
                { staticClass: "form-check-label", attrs: { for: "rep-draw" } },
                [_vm._v("Dibujar mi firma")]
              )
            ]),
            _c("div", { staticClass: "form-check" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.representationMode,
                    expression: "representationMode"
                  }
                ],
                staticClass: "form-check-input",
                attrs: { type: "radio", id: "rep-upload", value: "upload" },
                domProps: { checked: _vm._q(_vm.representationMode, "upload") },
                on: {
                  change: function($event) {
                    _vm.representationMode = "upload"
                  }
                }
              }),
              _c(
                "label",
                {
                  staticClass: "form-check-label",
                  attrs: { for: "rep-upload" }
                },
                [_vm._v("Subir imagen PNG")]
              )
            ])
          ]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.representationMode === "draw",
                  expression: "representationMode === 'draw'"
                }
              ]
            },
            [
              _c("vueSignature", {
                key: _vm.signaturePadKey,
                ref: "signaturePadCanvas",
                staticClass: "form-control",
                attrs: {
                  sigOption: {
                    penColor: "rgb(0, 0, 0)",
                    backgroundColor: "transparent"
                  },
                  w: "100%",
                  h: "150px"
                }
              }),
              _c(
                "div",
                {
                  staticClass: "btn-group btn-group-sm mt-2",
                  attrs: { role: "group" }
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-info btn-sm",
                      on: { click: _vm.clearSignature }
                    },
                    [_vm._v("Limpiar")]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-sm",
                      on: { click: _vm.saveSignature }
                    },
                    [_vm._v("Usar")]
                  )
                ]
              )
            ],
            1
          ),
          _vm.representationMode === "upload"
            ? _c("div", [
                _c("input", {
                  ref: "representationInput",
                  staticClass: "form-control-file",
                  attrs: { type: "file", accept: "image/png,image/jpeg" },
                  on: { change: _vm.onRepresentationSelected }
                })
              ])
            : _vm._e(),
          _vm.localRepresentationPreview || _vm.config.representacion
            ? _c("div", { staticClass: "mt-3 text-center" }, [
                _c("label", { staticClass: "small text-muted" }, [
                  _vm._v("Rúbrica actual:")
                ]),
                _c("br"),
                _c("img", {
                  staticClass: "border rounded",
                  staticStyle: { "max-width": "300px", "max-height": "100px" },
                  attrs: {
                    src: _vm.localRepresentationPreview || _vm.imageFullUrl,
                    alt: "Rúbrica actual"
                  }
                })
              ])
            : _vm._e(),
          _c(
            "div",
            { staticClass: "text-right mt-3" },
            [
              _c(
                "b-button",
                {
                  staticClass: "mr-2",
                  attrs: { variant: "secondary", size: "sm" },
                  on: {
                    click: function($event) {
                      return _vm.$refs.rubricaModal.hide()
                    }
                  }
                },
                [_vm._v("Cerrar")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }